import { useEffect } from 'react';

/**
 * Removes the legacy .rarea CSS class from the #rarea layout container
 * while the calling component is mounted. This prevents .rarea element-level
 * selectors (h1, p, a, table, etc.) from overriding KeyDS component styles.
 *
 * The layout margin is preserved via an inline style so the sidebar offset
 * is maintained. The class is restored on unmount.
 */
export default function useDisableRareaStyles() {
  useEffect(() => {
    const el = document.getElementById('rarea');
    if (!el) return undefined;

    const computedMargin = window.getComputedStyle(el).marginLeft;
    el.classList.remove('rarea');
    el.style.marginLeft = computedMargin;

    return () => {
      el.classList.add('rarea');
      el.style.marginLeft = '';
    };
  }, []);
}
